export default __webpack_public_path__ + "static/media/Teaser.b1707166.png";